<template>
    <div class="dropDownmenu-chat trans-04 pos-fixed" v-if="rightSideBarOpened" :class="{'hide-dropDown-menu': opened}" id="right-side-menu">

        <div class="right-sidebar-content-main-wrapper">
            <div class="right-sidebar-header pos-relative p-all-15 dis-flex flex-m flex-sb">
                <div class="dis-flex flex-m">
                    <div class="icon-shape mr-3 fs-25">
                        <svg viewBox="0 0 24 24" width="1em">
                            <rect width="9" height="9" x="2" y="2" class="uim-primary" rx="1"></rect>
                            <rect width="9" height="9" x="2" y="13" class="uim-tertiary" rx="1"></rect>
                            <rect width="9" height="9" x="13" y="2" class="uim-tertiary" rx="1"></rect>
                            <rect width="9" height="9" x="13" y="13" class="uim-tertiary" rx="1"></rect>
                        </svg>
                    </div>
                    <div class="dis-flex flex-column">
                        <h6 class="font-h-6">Chat / To do list</h6>
                        <span class="text-sm text-rose">Tasks</span>
                    </div>
                </div>
                <div class="sidebar-cat-icon-close dis-flex flex-m flex-c pointer" @click="opened = false">
                    <div class="uim-svg fs-19">
                        <svg data-name="Layer 1" viewBox="0 0 24 24" width="1em">
                            <path class="uim-primary" d="M13.41,12l4.3-4.29a1,1,0,1,0-1.42-1.42L12,10.59,7.71,6.29A1,1,0,0,0,6.29,7.71L10.59,12l-4.3,4.29a1,1,0,0,0,0,1.41h0a1,1,0,0,0,1.41,0h0L12,13.41l4.29,4.3a1,1,0,0,0,1.41,0h0a1,1,0,0,0,0-1.42h0Z"></path>
                        </svg>
                    </div>
                </div>
            </div>
            <div class="row flex-c mt-2">
                <div class="col-lg-12 p-lr-0-sm">
                    <div class="nav-wrapper pos-relative end-0">
                        <ul class="nav flex-sb" role="tablist">
                            <li class="nav-item pointer">
                                <a class="mb-0 px-0 py-1 active" data-bs-toggle="tab" role="tab">
                                    <button type="button" class="btn btn-element" @click="selectedMenu = 'myChats'" :class="{'active-btn': selectedMenu == 'myChats'}">
                                        <i class="uis uis-comment-alt-lines mr-2"></i>Chat
                                    </button>
                                </a>
                            </li>
                            <li class="nav-item pointer">
                                <a class="mb-0 px-0 py-1" data-bs-toggle="tab" role="tab">
                                    <button type="button" class="btn btn-element" @click="selectedMenu = 'myTodoList'" :class="{'active-btn': selectedMenu == 'myTodoList'}">
                                        <i class="uis uis-clipboard-notes mr-2"></i>To do list
                                    </button>
                                </a>
                            </li>
                            <li class="nav-item pointer">
                                <a class="mb-0 px-0 py-1" data-bs-toggle="tab" role="tab">
                                    <button type="button" class="btn btn-element" @click="selectedMenu = 'taskList'" :class="{'active-btn': selectedMenu == 'taskList'}">
                                        <i class="uis uis-layer-group mr-2"></i>Tasks
                                    </button>
                                </a>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
            <div class="tab-content">
                <div class="tab-pane fade mt-3 active show" v-if="selectedMenu == 'myChats'">
                    <div class="chat-all-conversations">
                        <input type="text" class="form-control mb-3 rightSidebar-conversations-search" placeholder="Search Conversations" aria-label="UserName">
                        <input type="text" class="form-control mb-3 rightSidebar-users-search" placeholder="Search Users" aria-label="UserName">
                        <div class="dis-flex p-1">
                            <div class="your-zone-location-time-wrapper">
                                <i class="uit uit-clock fs-14 mr-1 text-rose"></i>
                                <span class="text-sm-d">{{ getDateNow().hour }}:{{ getDateNow().minute }}</span>
                            </div>
                            <i class="uis uis-comment-alt-dots fs-18 mr-3 ml-auto pointer" title="Messages"></i>
                            <i class="uis uis-users-alt fs-18 pointer" title="Users"></i>
                        </div>
                        <div class="col-12 chat-messages-wrapper">
                            <div class="content-crds-messages-scroll">
                                
                            </div>
                        </div>
                        <div class="col-12 chat-users-wrapper">
                            <div class="content-crds-messages-scroll">
                                
                            </div>
                        </div>
                    </div>
                </div>
                <div class="tab-pane fade mt-3 active show" v-if="selectedMenu == 'myTodoList'">
                    <div class="todoListWrapper">
                    </div>
                </div>
                <div class="tab-pane fade mt-3 active show" v-if="selectedMenu == 'taskList'">
                    <div class="kanban-container">
                        <div id="myKanban"></div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import dateMixin from '@/mixins/dateMixin.js'

export default {
    data() {
        return {
            rightSideBarOpened: false,
            opened: false,
            selectedMenu: 'myChats'
        }
    },
    mixins: [dateMixin],
    watch: {
        'rightSideBarOpened': function(newValue, oldValue) {
            setTimeout(() => {
                this.opened = newValue
            }, 100);
        },
        'opened': function(newValue, oldValue) {
            if (this.rightSideBarOpened != newValue) {
                setTimeout(() => {
                    this.rightSideBarOpened = newValue
                }, 400);
            }

            if (newValue && device.type === 'mobile') {
                $('html').addClass('overf-hidden');
                $('body').addClass('overf-hidden');
            } else if (!newValue && device.type === 'mobile') {
                $('html').removeClass('overf-hidden');
                $('body').removeClass('overf-hidden');
            }
        }
    }
}
</script>

<style>

</style>